import { render, staticRenderFns } from "./LeaveHospital.vue?vue&type=template&id=22ca6428&scoped=true"
import script from "./LeaveHospital.vue?vue&type=script&lang=js"
export * from "./LeaveHospital.vue?vue&type=script&lang=js"
import style0 from "./LeaveHospital.vue?vue&type=style&index=0&id=22ca6428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ca6428",
  null
  
)

export default component.exports